// extracted by mini-css-extract-plugin
module.exports = {"radio_box":"radio_box--DwtQX","active":"active--3_L-t","radio":"radio--1Y2ah"};